<template>
	<form class="form-horizontal">
		<div class="animated fadeIn">
			<b-card>
				<div class="display-table full-width mb-2">
					<strong class="card-title">{{$route.meta.label}}</strong>
				</div>
				<b-row>
					<ResponseAlert ref="response" />
					<b-col md="6" class="mb-2">

						<b-form-group v-bind:class="{ 'is-invalid': errors.has('Kode')}" label="Kode">
							<b-form-input class="disabled" disabled v-model="models.kodePelakuUsaha" v-validate="'required'" data-vv-name="Kode">
							</b-form-input>
							<div v-if="errors.has('Kode')">
								<p class="text-danger">{{ errors.first('Kode') }}</p>
							</div>
						</b-form-group>
						<b-form-group v-bind:class="{ 'is-invalid': errors.has('Nama')}" label="Nama">
							<b-form-input class="disabled" disabled v-model="models.namaPelakuUsaha" v-validate="'required'" data-vv-name="Nama">
							</b-form-input>
							<div v-if="errors.has('Nama')">
								<p class="text-danger">{{ errors.first('Nama') }}</p>
							</div>
						</b-form-group>
						<b-form-group v-bind:class="{ 'is-invalid': errors.has('Jenis Izin Usaha')}" label="Jenis Izin Usaha">
							<select disabled v-model="models.jenisIzinDokumen" v-validate="'required'" data-vv-name="Jenis Izin Usaha"
								class="form-control disabled">
								<option value="">Pilih Jenis Izin Dokumen</option>
								<option v-for="(v,i) in masters.jenis_izin_dokumen" :value="v.id" :key="i">
									{{v.name}}
								</option>
							</select>
							<div v-if="errors.has('Jenis Izin Usaha')">
								<p class="text-danger">{{ errors.first('Jenis Izin Usaha') }}</p>
							</div>
						</b-form-group>
						<b-form-group v-bind:class="{ 'is-invalid': errors.has('Jenis Usaha Kegiatan')}" label="Jenis Usaha Kegiatan">
							<select disabled  v-model="models.jenisUsahaKegiatan" v-validate="'required'" data-vv-name="Jenis Usaha Kegiatan"
								class="form-control disabled">
								<option value="">Pilih Jenis Usaha Kegiatan</option>
								<option v-for="(v,i) in masters.jenis_usaha_kegiatan" :value="v.id" :key="i">
									{{v.name}}
								</option>
							</select>
							<div v-if="errors.has('Jenis Usaha Kegiatan')">
								<p class="text-danger">{{ errors.first('Jenis Usaha Kegiatan') }}</p>
							</div>
						</b-form-group>

						

						

						
					</b-col>
					<b-col md="6" class="mb-2">
						<b-form-group v-bind:class="{ 'is-invalid': errors.has('Status Usaha')}" label="Status Usaha">
							<select disabled v-model="models.stsUsaha" v-validate="'required'" data-vv-name="Status Usaha"
								class="form-control disabled">
								<option value="">Pilih Status Usaha</option>
								<option v-for="(v,i) in masters.status_usaha" :value="v.id" :key="i">
									{{v.name}}
								</option>
							</select>
							<div v-if="errors.has('Status Usaha')">
								<p class="text-danger">{{ errors.first('Status Usaha') }}</p>
							</div>
						</b-form-group>
						<b-form-group v-bind:class="{ 'is-invalid': errors.has('Telepon')}" label="Telepon">
							<b-form-input class="disabled" disabled v-model="models.telepon" v-validate="'required'" data-vv-name="Telepon">
							</b-form-input>
							<div v-if="errors.has('Telepon')">
								<p class="text-danger">{{ errors.first('Telepon') }}</p>
							</div>
						</b-form-group>

						<b-form-group v-bind:class="{ 'is-invalid': errors.has('Email')}" label="Email">
							<b-form-input class="disabled" disabled  v-model="models.email" v-validate="'required|email'" data-vv-name="Email">
							</b-form-input>
							<div v-if="errors.has('Email')">
								<p class="text-danger">{{ errors.first('Email') }}</p>
							</div>
						</b-form-group>
						<b-form-group v-bind:class="{ 'is-invalid': errors.has('Penanggung Jawab')}" label="Penanggung Jawab">
							<b-form-input class="disabled" disabled  v-model="models.penanggungjawab" v-validate="'required'" data-vv-name="Penanggung Jawab">
							</b-form-input>
							<div v-if="errors.has('Penanggung Jawab')">
								<p class="text-danger">{{ errors.first('Penanggung Jawab') }}</p>
							</div>
						</b-form-group>
					</b-col>
					<h5 class="col-md-12 mb-3 mt-5">Spesifikasi Usaha</h5>
					<b-col md="4" class="mb-2">
						<b-form-group v-bind:class="{ 'is-invalid': errors.has('Jumlah Lantai')}" label="Jumlah Lantai">
							<b-form-input class="disabled" disabled  type="number" v-model="models.jmlLantai" v-validate="'required'" data-vv-name="Jumlah Lantai">
							</b-form-input>
							<div v-if="errors.has('Jumlah Lantai')">
								<p class="text-danger">{{ errors.first('Jumlah Lantai') }}</p>
							</div>
						</b-form-group>
						<b-form-group v-bind:class="{ 'is-invalid': errors.has('Jumlah Ruangan')}" label="Jumlah Ruangan">
							<b-form-input class="disabled" disabled  type="number" v-model="models.jmlRuangan" v-validate="'required'" data-vv-name="Jumlah Ruangan">
							</b-form-input>
							<div v-if="errors.has('Jumlah Ruangan')">
								<p class="text-danger">{{ errors.first('Jumlah Ruangan') }}</p>
							</div>
						</b-form-group>
					</b-col>
					<b-col md="4" class="mb-2">
						<b-form-group v-bind:class="{ 'is-invalid': errors.has('Jumlah Karyawan')}" label="Jumlah Karyawan">
							<b-form-input class="disabled" disabled  type="number" v-model="models.jmlKaryawan" v-validate="'required'" data-vv-name="Jumlah Karyawan">
							</b-form-input>
							<div v-if="errors.has('Jumlah Karyawan')">
								<p class="text-danger">{{ errors.first('Jumlah Karyawan') }}</p>
							</div>
						</b-form-group>
						<b-form-group v-bind:class="{ 'is-invalid': errors.has('Jumlah Penghuni')}" label="Jumlah Penghuni">
							<b-form-input class="disabled" disabled  type="number" v-model="models.jmlPenghuni" v-validate="'required'" data-vv-name="Jumlah Penghuni">
							</b-form-input>
							<div v-if="errors.has('Jumlah Penghuni')">
								<p class="text-danger">{{ errors.first('Jumlah Penghuni') }}</p>
							</div>
						</b-form-group>
					</b-col>
					<b-col md="4" class="mb-2">
						<b-form-group v-bind:class="{ 'is-invalid': errors.has('Jumlah Hari Operasional')}" label="Jumlah Hari Operasional">
							<b-form-input class="disabled" disabled  type="number" v-model="models.jmlHariOps" v-validate="'required'" data-vv-name="Jumlah Hari Operasional">
							</b-form-input>
							<div v-if="errors.has('Jumlah Hari Operasional')">
								<p class="text-danger">{{ errors.first('Jumlah Hari Operasional') }}</p>
							</div>
						</b-form-group>
					</b-col>
					<h5 class="col-md-12 mb-3 mt-5">Lokasi Usaha</h5>
					<b-col md="6" class="mb-2">
						<b-form-group v-bind:class="{ 'is-invalid': errors.has('Alamat')}" label="Alamat">
							<textarea disabled  class="form-control disabled" v-model="models.alamatPu" v-validate="'required'" data-vv-name="Alamat"></textarea>
							<div v-if="errors.has('Alamat')">
								<p class="text-danger">{{ errors.first('Alamat') }}</p>
							</div>
						</b-form-group>
						<b-form-group v-bind:class="{ 'is-invalid': errors.has('Kota')}" label="Kota">
							<select disabled v-model="models.kotaId" v-validate="'required'" @change="getDistrictByCity(true)" data-vv-name="Kota"
								class="form-control disabled">
								<option value="">Pilih Kota</option>
								<option v-for="(v,i) in masters.cities" :value="v.id" :key="i">
									{{v.namaKota}}
								</option>
							</select>
							<div v-if="errors.has('Kota')">
								<p class="text-danger">{{ errors.first('Kota') }}</p>
							</div>
						</b-form-group>
						<b-form-group v-bind:class="{ 'is-invalid': errors.has('Kecamatan')}" label="Kecamatan">
							<select disabled v-model="models.kecamatanId" v-validate="'required'" @change="getVillageByDistrict(true)" data-vv-name="Kecamatan"
								class="form-control disabled">
								<option value="">Pilih Kecamatan</option>
								<option v-for="(v,i) in masters.districts" :value="v.id" :key="i">
									{{v.namaKecamatan}}
								</option>
							</select>
							<div v-if="errors.has('Kecamatan')">
								<p class="text-danger">{{ errors.first('Kecamatan') }}</p>
							</div>
						</b-form-group>
					</b-col>
					<b-col md="6" class="mb-2">
						
						<b-form-group v-bind:class="{ 'is-invalid': errors.has('Kelurahan')}" label="Kelurahan">
							<select disabled v-model="models.kelurahanId" v-validate="'required'" data-vv-name="Kelurahan"
								class="form-control disabled">
								<option value="">Pilih Kelurahan</option>
								<option v-for="(v,i) in masters.villages" :value="v.id" :key="i">
									{{v.namaKelurahan}}
								</option>
							</select>
							<div v-if="errors.has('Kelurahan')">
								<p class="text-danger">{{ errors.first('Kelurahan') }}</p>
							</div>
						</b-form-group>
						<b-form-group label="Longitude">
							<b-form-input class="disabled" disabled v-model="models.longitude">
							</b-form-input>
						</b-form-group>
						<b-form-group label="Latitude">
							<b-form-input class="disabled" disabled v-model="models.latitude">
							</b-form-input>
						</b-form-group>
					</b-col>
				</b-row>
				<template #footer>
					<b-button type="button" variant="light" class="btn-min-width float-right" @click="$router.go(-1)">
						Kembali
					</b-button>
				</template>
			</b-card>
		</div>
	</form>
</template>
<style>
    .disabled {
        background: #fff!important;
        border: none;
    }
</style>
<script>
	import ResponseAlert from '@/components/response_alert';

	export default {
		name: 'ViewPelakuUsaha',
		components: {
			ResponseAlert,
		},
		data() {
			return {
				config: {
					uri: this.$route.meta.permission.link,
				},
				models: {
					kodePelakuUsaha: "",
					namaPelakuUsaha: "",
					jenisIzinDokumen: "",
					jenisUsahaKegiatan: "",
					stsUsaha: "",
					alamatPu: "",
					telepon: "",
					email: "",
					penanggungjawab: "",
					jmlLantai: 0,
					jmlRuangan: 0,
					jmlKaryawan: 0,
					jmlPenghuni: 0,
					jmlHariOps: 0,
					longitude: "",
					latitude: "",
					kelurahanId: "",
					kotaId: "",
					kecamatanId: "",
					createdBy: "",
					modifiedBy: "",
				},
				masters: {
					cities: [],
					districts: [],
					villages: [],
					jenis_usaha_kegiatan: [
						{
							id: '1',
							name: "APARTEMENT"
						},{
							id: '2',
							name: "BATERE SEL KERING"
						},{
							id: '3',
							name: "BENGKEL"
						},{
							id: '4',
							name: "CAT"
						},{
							id: '5',
							name: "CONSUMER GOODS"
						},{
							id: '6',
							name: "DISTRIBUSI MIGAS"
						},{
							id: '7',
							name: "DISTRIBUTOR ALAT LAB DAN ALAT KESEHATAN"
						},{
							id: '8',
							name: "ELEKTRONIK"
						},{
							id: '9',
							name: "FARMASI"
						},{
							id: '10',
							name: "HOTEL"
						},{
							id: '11',
							name: "JASA PENGELOLAAN LIMBAH B3"
						},{
							id: '12',
							name: "JASA PENGENDALIAN HAMA"
						},{
							id: '13',
							name: "KIMIA"
						},{
							id: '14',
							name: "LABORATORIUM"
						},{
							id: '15',
							name: "LABORATORIUM KESEHATAN"
						},{
							id: '16',
							name: "MAKANAN DAN MINUMAN"
						},{
							id: '17',
							name: "MIGAS EP"
						},{
							id: '18',
							name: "MINYAK NABATI"
						},{
							id: '19',
							name: "OTOMOTIF"
						},{
							id: '20',
							name: "PABRIKASI"
						},{
							id: '21',
							name: "PELEBURAN LOGAM"
						},{
							id: '22',
							name: "PEMBANGKIT ENERGI"
						},{
							id: '23',
							name: "PENGOLAHAN LOGAM"
						},{
							id: '24',
							name: "PERGUDANGAN"
						},{
							id: '25',
							name: "PUSAT KESEHATAN MASYARAKAT"
						},{
							id: '26',
							name: "RUMAH SAKIT"
						},{
							id: '27',
							name: "SAWIT"
						},{
							id: '28',
							name: "TAMBANG"
						},{
							id: '29',
							name: "TEKSTIL"
						},{
							id: '30',
							name: "TERMINAL"
						},{
							id: '31',
							name: "UTILITY"
						}
					],
					jenis_izin_dokumen: [
						{
							id: '1',
							name: "PEL"
						},{
							id: '2',
							name: "ANDAL"
						},{
							id: '3',
							name: "RKL-RPL"
						},{
							id: '4',
							name: "DPPL"
						},{
							id: '5',
							name: "DELH"
						},{
							id: '6',
							name: "IJIN LINGKUNGAN"
						}
					],
					status_usaha: [
						{
							id: '0',
							name: "Tidak Aktif"
						},{
							id: '1',
							name: "Aktif"
						}
					]
				},
			}
		},
		created() {
			const _ = this
			_.getById();
			_.getCities();
		},
		methods: {
			async getById() {
				const _ = this;
				try {
					if (_.$route.params.id) {
						const request = await _.$axios.get(`PelakuUsaha/${_.$route.params.id}`);
						const data = request.data.data;
						_.models.kodePelakuUsaha = data.kodePelakuUsaha;
						_.models.namaPelakuUsaha = data.namaPelakuUsaha;
						_.models.jenisIzinDokumen = data.jenisIzinDokumen;
						_.models.jenisUsahaKegiatan = data.jenisUsahaKegiatan;
						_.models.stsUsaha = data.stsUsaha;
						_.models.alamatPu = data.alamatPu;
						_.models.telepon = data.telepon;
						_.models.email = data.email;
						_.models.penanggungjawab = data.penanggungjawab;
						_.models.jmlLantai = data.jmlLantai;
						_.models.jmlRuangan = data.jmlRuangan;
						_.models.jmlKaryawan = data.jmlKaryawan;
						_.models.jmlPenghuni = data.jmlPenghuni;
						_.models.jmlHariOps = data.jmlHariOps;
						_.models.kotaId = data.kotaId;
						_.models.kecamatanId = data.kecamatanId;
						_.models.kelurahanId = data.kelurahanId;
						_.models.longitude = data.longitude;
						_.models.latitude = data.latitude;
						_.models.createdBy = data.createdBy;
						_.models.modifiedBy = data.modifiedBy;
						_.getDistrictByCity(false);
						_.getVillageByDistrict(false);
					}
				} catch (error) {
					_.$router.push({ name: 'page404' });
				}
				
			},
			getCities(reset = true) {
				const _ = this
				_.$axios.get('Kota')
				.then(res => {
					_.masters.cities = res.data.data;
				});
			},
			getDistrictByCity(reset = true) {
				const _ = this
				_.$axios.get('Kecamatan/ByKotaId/' + _.models.kotaId)
				.then(res => {
					if(reset === true){
						_.models.kecamatanId = "";
						_.models.kelurahanId = "";
					}
					_.masters.districts = res.data.data;
				});
			},
			getVillageByDistrict(reset = true) {
				const _ = this
				_.$axios.get('Kelurahan/ByKecamatanId/' + _.models.kecamatanId)
				.then(res => {
					if(reset === true){
						_.models.kelurahanId = "";
					}
					_.masters.villages = res.data.data;
				});
			},
		}
	}
</script>